<template>
  <div id="referFriends">
    <div class="content_box">
      <div class="inner">
        <div class="contact_title">
          <h2>{{ $t('promotion.referFriends.referAFriend') }}</h2>
        </div>
        <div class="raf-button-wrapper">
          <el-button
            v-for="button in SWITCH_TABS"
            :key="button.value"
            class="el-button"
            v-bind:class="[button.value === activedTab ? 'blue_button' : 'white_button']"
            @click="activedTab = button.value"
          >
            {{ $t(button.i18Label) }}
          </el-button>
        </div>
        <div class="my-[45px]">
          <Overview
            v-bind="campaignInfo"
            v-if="activedTab === OVERVIEW_TAB"
            @clickRedeem="onClickRedeem"
            :referralLink="referralLink"
            :referAFriendID="referAFriendID"
            :isRafIndia="isRafIndia"
          />
          <Referrals
            v-if="activedTab === REFERRALS_TAB"
            v-bind="campaignInfo"
            @clickRedeem="onClickRedeem"
            :isRafIndia="isRafIndia"
          />
        </div>
      </div>
    </div>
    <RedeemPopup
      :redeemVisible.sync="redeemVisible"
      :campaignId="referAFriendID"
      v-bind="popupProps"
      @redeemSuccess="getApiReferralList"
      :isRafIndia="isRafIndia"
    />
  </div>
</template>
<script>
import RedeemPopup from '@/components/referFriends/redeem/RedeemPopup.vue';
import { apiCampaignInfo, apiRedeemableAcc, apiReferralLink } from '@/resource';
import Overview from '@/components/referFriends/overview/Overview.vue';
import Referrals from '@/components/referFriends/referrals/Referrals.vue';
import { PROMOTION_TYPE } from '@/constants/promotion';

const OVERVIEW_TAB = 'overview-tab';
const REFERRALS_TAB = 'referrals-tab';
const SWITCH_TABS = [
  {
    i18Label: 'common.overview',
    value: OVERVIEW_TAB
  },
  {
    i18Label: 'common.referrals',
    value: REFERRALS_TAB
  }
];

export default {
  name: 'ReferFriend',
  components: {
    RedeemPopup,
    Overview,
    Referrals
  },
  data() {
    return {
      OVERVIEW_TAB,
      REFERRALS_TAB,
      SWITCH_TABS,
      activedTab: OVERVIEW_TAB,
      campaignInfo: {},
      redeemVisible: false,
      popupProps: {
        accNums: [],
        participantIds: [],
        amount: 0
      },
      referralLink: null
    };
  },
  computed: {
    referAFriendID() {
      let referAFriend = this.$store.state.promotion.eligibleCampaigns.find(
        c => c.campaignType === PROMOTION_TYPE.REFER_A_FRIEND_V10
      );
      return referAFriend ? referAFriend.id : '';
    },
    isRafIndia() {
      return this.referAFriendID === 54;
    },
    lang() {
      return this.$store.state.common.lang;
    },
    languagePath() {
      switch (this.lang) {
        case 'zh_CN':
          return this.GLOBAL_DOMAIN_WEBSITECN;
        case 'zh_TW':
          return this.GLOBAL_DOMAIN_WEBSITETW;
        default:
          return this.$config.info.getUrl(this.regulator);
      }
    }
  },
  mounted() {
    Promise.all([this.getApiReferralList(), this.getApiReferralLink()]);
  },
  methods: {
    getApiReferralList() {
      apiCampaignInfo(this.referAFriendID).then(resp => {
        if (resp.data.code === 0) {
          this.campaignInfo = resp.data.data;
        }
      });
    },
    getApiReferralLink() {
      const languagePath = this.languagePath;
      const languageSuffix = !['th'].includes(this.lang) ? '' : '/' + this.lang;

      apiReferralLink(this.referAFriendID).then(resp => {
        if (resp.data.code === 0 && resp.data.data != '') {
          this.referralLink =
            `https://${languagePath}${languageSuffix}/trade-now/?utm_source=promo&utm_medium=social&utm_campaign=RAF&utm_term=NA&utm_content=NA&c=` +
            encodeURIComponent(resp.data.data);
        }
      });
    },
    onClickRedeem(ids, amount) {
      this.popupProps.participantIds = ids;
      this.popupProps.amount = amount;
      apiRedeemableAcc(this.referAFriendID).then(resp => {
        if (resp.data.code === 0) {
          this.popupProps.accNums = resp.data.data;
          this.redeemVisible = true;
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/pages/promotion/referFriends.scss';
</style>
